import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const navLinks = ["home", "about", "services", "projects", "contact"];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      const sections = navLinks.map((id) => document.getElementById(id));
      const scrollPos = window.scrollY + 120;

      sections.forEach((section, index) => {
        if (section) {
          const top = section.offsetTop;
          const height = section.offsetHeight;

          if (scrollPos >= top && scrollPos < top + height) {
            setActive(navLinks[index]);
          }
        }
      });
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    setOpen(false);

    const element = document.getElementById(id);

    if (element) {
      const yOffset = -90;
      const y =
        element.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  return (
    <nav
  className={`fixed w-full z-50 transition-all duration-500 ${
    scrolled
      ? "bg-white/95 backdrop-blur-xl shadow-lg py-3"
      : "bg-white/70 backdrop-blur-md py-5"
  }`}
>
    
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-10">
        {/* LOGO */}
        <button
  onClick={() => window.open("/logo.jpg", "_blank")}
  className="flex items-center gap-2"
>

  {/* Logo */}
  <img
    src="/favicon.jpg"
    alt="Aysu Groups"
    className="w-11 h-11 rounded-full object-cover shadow-md hover:scale-105 transition"
  />

  {/* Brand text */}
  <span className="text-xl sm:text-2xl font-black tracking-tight text-slate-950 hover:text-black transition">
    AYSU GROUPS
  </span>

</button>
       {/* DESKTOP MENU */}
<div className="hidden md:flex items-center gap-2 lg:gap-3">

  {navLinks.map((link) => (
    <button
      key={link}
      onClick={() => scrollToSection(link)}
      className={`relative capitalize px-4 py-2 rounded-full text-sm lg:text-[15px] font-semibold transition-all duration-300 ${
        active === link
          ? "text-black bg-black/5"
          : "text-slate-950 hover:text-black hover:bg-black/5"
      }`}
    >
      {link}

      {/* active indicator */}
      {active === link && (
        <motion.span
          layoutId="nav-pill"
          className="absolute inset-0 rounded-full border border-black/10"
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
        />
      )}
    </button>
  ))}

  {/* PREMIUM QUOTE BUTTON */}
  <button
    onClick={() => scrollToSection("contact")}
    className="ml-3 relative overflow-hidden rounded-full bg-slate-950 text-white px-7 py-2.5 text-sm font-bold shadow-lg transition duration-300 hover:scale-105 group"
  >
    {/* animated gradient glow */}
    <span className="absolute inset-0 bg-gradient-to-r from-teal-500 via-cyan-500 to-emerald-500 opacity-0 group-hover:opacity-100 transition duration-300"></span>

    {/* text */}
    <span className="relative z-10">Quote</span>
  </button>

</div>

        {/* MOBILE BUTTON */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden inline-flex items-center justify-center rounded-xl p-2 text-slate-950 hover:bg-black/5 transition"
          aria-label="Toggle menu"
        >
          <span className="text-2xl leading-none">{open ? "✕" : "☰"}</span>
        </button>
      </div>

      {/* MOBILE MENU */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.25 }}
            className="md:hidden px-4 pt-3"
          >
            <div className="mx-auto max-w-7xl overflow-hidden rounded-3xl border border-black/5 bg-white/95 shadow-[0_18px_50px_rgba(15,23,42,0.10)] backdrop-blur-2xl">
              <div className="flex flex-col p-4">
                {navLinks.map((link) => (
                  <button
                    key={link}
                    onClick={() => scrollToSection(link)}
                    className={`text-left capitalize rounded-2xl px-4 py-3 text-base font-semibold transition ${
                      active === link
                        ? "bg-black/5 text-black"
                        : "text-slate-950 hover:bg-black/5 hover:text-black"
                    }`}
                  >
                    {link}
                  </button>
                ))}

                <button
                  onClick={() => scrollToSection("contact")}
                  className="mt-3 rounded-2xl bg-slate-950 py-3 text-base font-bold text-white transition hover:bg-black"
                >
                  Hire Us
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}